import { TimeCharter } from "../models/search.interfaces";
import { uniqBy } from "lodash";

// Specs in tickets: 271995 and 278747
export const parseSortAndFilterTcs = (dbString: string) => {
  try {
    const timeCharters = _parseDbStringToTcData(dbString);
    const uniqueTimeCharters = uniqBy(timeCharters, "tccode");
    const sortedTimeCharters = uniqueTimeCharters.sort(
      (a, b) => new Date(b.cp_date!).getTime() - new Date(a.cp_date!).getTime(),
    );

    const tcCodes =
      sortedTimeCharters.length > 0 ? sortedTimeCharters.map((tc) => tc.tccode!).join(",") : "No valid records found";

    const deliveredTCs = sortedTimeCharters.filter((tc) => tc.tc_status === "Delivered");
    const cpDate =
      deliveredTCs.length > 0
        ? deliveredTCs[0]
        : sortedTimeCharters.find((tc) => ["On Subjects", "Opportunity", "Fixed"].includes(tc.tc_status ?? ""));

    return { tcCodes, cpDate };
  } catch (error) {
    throw new Error("Error parsing data");
  }
};

// This parsing will eventually be removed, it's planned to be replaced by the BE sending JSON directly
// Example dataString: 'tccode: 95RG6-I0008 | tc_status: Delivered | cp_date: 2024-06-19 | Delivery_dt: 2024-06-25 22:00:00.000 | Redelivery_dt: 2024-08-01 08:29:00.000 | TC_owner: F.H. BERTLING CHARTERING 030937 ~ tccode: 95RG6-I0006 | tc_status: Redelivered | cp_date: 2023-10-04 | Delivery_dt: 2023-10-10 05:01:00.000 | Redelivery_dt: 2024-03-09 22:00:00.000 | TC_owner: F.H.BERTLING CHARTERING A 030937'
export function _parseDbStringToTcData(dataString: string): TimeCharter[] {
  return dataString
    .split("~")
    .map((tc) => {
      const tcDto = Object.fromEntries(
        tc
          .split(" | ")
          .map((field) => {
            const [key, value] = field.split(": ");
            return [key, value].map((s) => s?.trim());
          })
          .filter(([key, value]) => key && value),
      ) as TimeCharter;

      if (!tcDto.cp_date || !tcDto.tccode) {
        return null;
      }

      return tcDto;
    })
    .filter((tc): tc is TimeCharter => tc !== null);
}
